<template>
  <div>
    <TabsLayout>
      <ElTabPane name="tagsstyles" label="素材样式" v-if="authMaterialStyles"></ElTabPane>
      <ElTabPane name="tags3dvideosource" label="3D视频源" v-if="authTagVideoSource"></ElTabPane>
      <ElTabPane name="tagsindex" label="内容标签" v-if="authIndex"></ElTabPane>
      <ElTabPane name="tagsmarketing" label="营销主题标签" v-if="authMarketing"></ElTabPane>
      <ElTabPane name="tagsgroup" label="内容标签组" v-if="authTagGroup"></ElTabPane>
      <ElTabPane name="tagsai" label="AI标签"></ElTabPane>
      <ElTabPane name="tagskeyword" label="关键词"></ElTabPane>
    </TabsLayout>
  </div>
</template>
<script>
import TabsLayout from '@/views/report/tabs-layout.vue'

export default {
  components: {
    TabsLayout
  },
  name: 'tags',
  computed: {
    authIndex() {
      return this.$store.state.accessAuth.includes('M20836')
    },
    authMarketing() {
      return this.$store.state.accessAuth.includes('M20837')
    },
    authTagGroup() {
      return this.$store.state.accessAuth.includes('M21037')
    },
    authTagVideoSource() {
      return this.$store.state.accessAuth.includes('M21083')
    },
    authMaterialStyles() {
      return this.$store.state.accessAuth.includes('M21205')
    }
  }
}
</script>
<style lang="scss" scoped></style>
